import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import App from './App';
import { NBAInsightsContextProvider } from './context/global-state';
import { theme } from './theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Auth0Provider
    domain={window.env.AUTH_DOMAIN === "__AUTH_DOMAIN__" ? process.env.REACT_APP_AUTH_DOMAIN! : window.env.AUTH_DOMAIN}
    clientId={window.env.AUTH_CLIENT_ID === "__AUTH_CLIENT_ID__" ? process.env.REACT_APP_AUTH_CLIENT_ID! : window.env.AUTH_CLIENT_ID} 
    authorizationParams={{
      redirect_uri: window.env.AUTH_CALLBACK_URL === "__AUTH_CALLBACK_URL__" ? process.env.REACT_APP_AUTH_CALLBACK_URL : window.env.AUTH_CALLBACK_URL,
      audience: window.env.AUTH_AUDIENCE === "__AUTH_AUDIENCE__" ? process.env.REACT_APP_AUTH_AUDIENCE : window.env.AUTH_AUDIENCE
    }}
  >
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <Notifications autoClose={4000} limit={2} position="bottom-right" />
      <BrowserRouter>
        <NBAInsightsContextProvider>
          <App />
        </NBAInsightsContextProvider>
      </BrowserRouter>
    </MantineProvider>
  </Auth0Provider>
);
